import { CSSProperties } from 'react';
import { Box, Typography } from '@/lib/mui';

interface IconProps {
  s: CSSProperties;
}

interface Props {
  Icon?: React.FC<IconProps>;
  title?: string;
  desc?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export default function Section({ Icon, title, desc, children, style }: Props) {
  return (
    <Box
      padding={{ xs: 3, md: 5 }}
      width={{
        xs: 'calc(100% - 3rem)',
        md: 'calc(100% - 5rem)',
      }}
      style={{
        maxWidth: '550px',
        minHeight: 200,
        borderRadius: 20,
        background: '#FFF',
        boxShadow: '0px 4px 14px 0px rgba(0, 0, 0, 0.05)',
        ...style,
      }}
    >
      <Box display="flex" justifyContent="center">
        <div style={{ height: 40, width: 40 }}>
          {Icon ? <Icon s={{ width: 40, height: 40 }} /> : null}
        </div>
      </Box>
      <Box mt={2} />
      <Typography textAlign="center" variant="h6">
        {title}
      </Typography>
      <Typography textAlign="center" mt={1} variant="body1">
        {desc}
      </Typography>
      <Box mt={1}>{children}</Box>
    </Box>
  );
}
